import { useState, useEffect } from 'react';

/**
 * Hook that detects if user prefers reduced motion or is on mobile device.
 * Used to disable heavy animations for better performance.
 */
export const useReducedMotion = () => {
  const [shouldReduceMotion, setShouldReduceMotion] = useState(false);

  useEffect(() => {
    // Check for prefers-reduced-motion
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    // Check if mobile device (width < 768px)
    const isMobile = window.innerWidth < 768;
    
    setShouldReduceMotion(mediaQuery.matches || isMobile);

    const handleChange = (e: MediaQueryListEvent) => {
      setShouldReduceMotion(e.matches || window.innerWidth < 768);
    };

    const handleResize = () => {
      setShouldReduceMotion(mediaQuery.matches || window.innerWidth < 768);
    };

    mediaQuery.addEventListener('change', handleChange);
    window.addEventListener('resize', handleResize);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return shouldReduceMotion;
};

export default useReducedMotion;
